import { Box, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import { purchaseOrderListIpbAction } from '_models/redux/purchase_order_list/action';
import { cleanPurchaseOrderListClean } from '_models/redux/purchase_order_list/clean-action';
import { purchaseOrderDetailListIpbAction } from '_models/redux/purchase_order_list_details/action';
import { cleanDetailPurchaseOrderListIpbAction } from '_models/redux/purchase_order_list_details/clean-action';
import { useState } from 'react';
import { connect } from 'react-redux';
import CustomDialog from 'widgets/component/CustomDialog';
import DataTableDetailOrder from 'widgets/customDialogComponentDetails/ComponentDialog';
import DataTable from 'widgets/datagrid/DataTable';
import FiltroListIpb from './components/FiltroListIpb';
import { useListSimIpb } from './hooks/useListSimIpb';

const PageOrderListIpb = ({
  purchaseOrderListIpbAction,
  purchaseOrderListIpb,
  cleanPurchaseOrderListClean,
  purchaseOrderDetailListIpbAction,
  purchaseOrderListDetailsIpb,
  cleanDetailPurchaseOrderListIpbAction,
  onClose,
}) => {
  const {
    register,
    handleSubmit,
    errors,
    onSubmit,
    handleCleanFilters,
    loading,
    page,
    size,
    pagination,
    mappedRows,
    handleRowClick,
    Columns,
    isDialogOpen,
    dialogMessage,
    handleClose,
    isDialogOpenDetails,
    errorMessage,
    getBackgroundColor,
    handleOpenPopUp,
  } = useListSimIpb({
    purchaseOrderListIpbAction,
    purchaseOrderListIpb,
    cleanPurchaseOrderListClean,
    purchaseOrderDetailListIpbAction,
    purchaseOrderListDetailsIpb,
    cleanDetailPurchaseOrderListIpbAction,
    onClose,
  });

  // Estado para controlar si ya se realizó una búsqueda
  const [hasSearched, setHasSearched] = useState(false);

  // Nueva función para marcar que ya se buscó
  const onSubmitWithFlag = (...args) => {
    setHasSearched(true);
    return onSubmit(...args);
  };

  return (
    <>
      <Grid>
        <h4>Órdenes de compra IPB </h4>
      </Grid>
      <Grid marginBottom={4}>
        <FiltroListIpb
          onSubmit={onSubmitWithFlag}
          handleSubmit={handleSubmit}
          errors={errors}
          register={register}
          onCleanFilters={handleCleanFilters}
        />
        {errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>}
      </Grid>
      <Grid>
        {mappedRows?.length > 0 ? (
          <Grid paddingRight={5} paddingLeft={0}>
            <Box sx={{ height: '67vh' }}>
              <DataTable
                rows={mappedRows}
                columns={Columns}
                onRowClick={handleRowClick}
                page={page}
                pageSize={size}
                rowCount={pagination?.total_rows ?? 0}
                onPageChange={pagination?.handleChangePage}
                handleChangePageSize={pagination?.handleChangePageSize}
                getBackgroundColor={getBackgroundColor}
                mappedRows={mappedRows}
                loading={loading}
              />
            </Box>
          </Grid>
        ) : (
          hasSearched && <Typography variant='h6'>No hay registros disponibles</Typography>
        )}
      </Grid>

      <CustomDialog
        fullWidth
        title={
          purchaseOrderListDetailsIpb?.response?.payment_info === null
            ? 'No hay datos'
            : 'Detalle Ordenes de Compra IPB'
        }
        content={
          <DataTableDetailOrder
            type='DetailsPurchaseOrdersIpb'
            handleOpenPopUp={handleOpenPopUp}
            response={purchaseOrderListDetailsIpb?.response}
            idTransaction={purchaseOrderListDetailsIpb?.response?.provider_type?.transaction_id}
            namePayment={purchaseOrderListDetailsIpb?.response?.provider_type?.name}
            onClose={handleClose}
          />
        }
        open={isDialogOpenDetails}
        onClose={handleClose}
        maxWidth='md'
        extraButtons={[
          {
            label: 'Aceptar',
            variant: 'contained',
            onClick: handleClose,
            buttonColor: 'purple',
            textColor: 'white',
          },
        ]}
      />

      <CustomDialog
        title='Mensaje'
        content={<p>{dialogMessage}</p>}
        open={isDialogOpen}
        onClose={handleClose}
        fullWidth
        maxWidth='sm'
        extraButtons={[
          {
            label: 'Aceptar',
            variant: 'contained',
            onClick: handleClose,
            buttonColor: 'purple',
            textColor: 'white',
          },
        ]}
      />
    </>
  );
};

const mapStateToProps = (state) => ({
  purchaseOrderListIpb: state?.purchaseOrderListIpb,
  purchaseOrderListDetailsIpb: state?.purchaseOrderListDetailsIpb,
});

const mapDispatchToProps = {
  purchaseOrderListIpbAction,
  cleanPurchaseOrderListClean,
  purchaseOrderDetailListIpbAction,
  cleanDetailPurchaseOrderListIpbAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(PageOrderListIpb);
